export default "__VITE_ASSET__BSWsaW6d__"